import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'
import { Button } from 'components/ui'

export const Wrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const MenuHeader = styled.div`
  padding: 0 0 0.4rem;
  height: 4.2rem;
  display: grid;
  grid-template-columns: 4.4rem 1fr 4.4rem;
  gap: 1.6rem;
  align-items: center;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.white01};
`

export const MenuHeaderTitle = styled.h4<{ type?: string }>`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 2rem;
  line-height: 1.5;
  text-align: center;
  color: ${(props) => props.theme.color.textSecondary};
  ${(props) =>
    props.type === 'start' &&
    css`
      grid-column: span 1;
    `}
`

export const MenuHeaderNothing = styled.span``

export const SettingsButton = styled(Button)`
  width: 4.4rem;
  height: 4.4rem;
  color: ${(props) => props.theme.color.textSecondary};
  background-color: ${(props) => transparentize(0.9, props.theme.color.elementBgSecond)};
  svg {
    transition: transform 0.2s ease-in-out;
  }
  &:hover:not([disabled]),
  &:focus:not([disabled]) {
    background-color: ${(props) => transparentize(0.86, props.theme.color.black)};
    svg {
      transform: rotate(90deg);
    }
  }
`

export const MenuHeaderClose = styled.span`
  position: relative;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.color.textSecondary};
  background-color: ${(props) => props.theme.color.transparent};
  border: none;
  outline: none;
  cursor: pointer;
`

export const Menu = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 0.4rem 0 0 0;
  width: 100%;
  background-color: ${(props) => props.theme.color.elementBg};
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  z-index: ${(props) => props.theme.zIndex.modal};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    position: absolute;
    top: calc(100% + 0.6rem);
    width: 48rem;
    height: fit-content;
  `};
`

export const MenuContent = styled.div<{ type: string }>`
  padding: 0;
  ${(props) =>
    props.type === 'global' &&
    css`
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
      gap: 1.2rem;
    `}
  ${(props) =>
    props.type === 'language' &&
    css`
      display: grid;
      grid-template-columns: repeat(4, 9.6rem);
      grid-template-rows: auto;
      gap: 0.4rem;
    `}
`

export const TriggerElement = styled.div`
  grid-area: trigger;
  padding: 0.4rem;
  display: flex;
  justify-content: flex-end;
  color: ${(props) => props.theme.color.textSecondary};
  transition: transform 0.2s ease-in-out;
`

export const MenuItem = styled.label`
  padding: 0.8rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto 1fr;
  gap: 1.2rem 1rem;
  align-items: space-between;
  grid-template-areas:
    'icon trigger'
    'info info';
  background-color: ${(props) => transparentize(0.9, props.theme.color.textSecondary)};
  border: 0.1rem solid ${(props) => transparentize(0.8, props.theme.color.default)};
  transition: border-color 0.2s ease-in-out;
  outline: none;
  cursor: pointer;
  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    border-color: ${(props) => props.theme.color.default};
  }
`

export const MenuItemIcon = styled.span`
  grid-area: icon;
  padding: 0.4rem 0;
  font-size: 2.8rem;
  line-height: 1;
  color: ${(props) => props.theme.color.textSecondary};
`

export const MenuItemInfo = styled.div`
  grid-area: info;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const MenuItemTitle = styled.h5`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.4rem;
  line-height: 1.43;
  color: ${(props) => props.theme.color.text};
`

export const MenuItemSubTitle = styled.p`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.2rem;
  line-height: 1.33;
  color: ${(props) => props.theme.color.textSecondary};
`

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.color.modalOverflow};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isOpen ? props.theme.opacity.default : props.theme.opacity.invisible)};
  transition: opacity 0.2s ease-out;
  z-index: ${(props) => props.theme.zIndex.modalContainer};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: none;
    visibility: hidden;
  `};
`

export const Badge = styled.span`
  margin: 0;
  padding: 0;
  flex: 0 0 auto;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.4rem;
  line-height: 1.43;
  color: ${(props) => props.theme.color.warning};
`
